
import {bzApi} from "@/axios";

// 查询项目共享人列表
export function listProjectSharerBz(projectId) {
    return bzApi({
        url: '/project/share/list/'+projectId,
        method: 'get',
    })
}
// 删除项目共享人
export function delProjectSharerBz(data) {
    return bzApi({
        url: '/project/share/delete',
        method: 'post',
        data:data
    })
}
export function addProjectSharerBz(data){
    return bzApi({
        url:'/project/share/add',
        method:'post',
        data:data
    })
}
